import React, { useEffect, useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const Lightbox = ({ images, startIndex, onClose }) => {
    const [currentIndex, setCurrentIndex] = useState(startIndex);

    const goToPrevious = () => {
        const isFirstImage = currentIndex === 0;
        const newIndex = isFirstImage ? images.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };

    const goToNext = () => {
        const isLastImage = currentIndex === images.length - 1;
        const newIndex = isLastImage ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    };

    // Efeito para navegação com as setas do teclado
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowLeft') {
                goToPrevious();
            } else if (e.key === 'ArrowRight') {
                goToNext();
            } else if (e.key === 'Escape') {
                onClose();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        // Limpa o evento ao desmontar o componente
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentIndex]); // Recria o listener quando o currentIndex muda para ter o valor atualizado

    if (!images || images.length === 0) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4" onClick={onClose}>
            {/* Botão de Fechar */}
            <button className="absolute top-4 right-4 text-white hover:opacity-80 transition-opacity z-50" onClick={onClose}>
                <X size={32} />
            </button>

            {/* Botão Anterior */}
            <button 
                className="absolute left-4 top-1/2 -translate-y-1/2 text-white bg-white/10 p-2 rounded-full hover:bg-white/20 transition-colors z-50" 
                onClick={(e) => { e.stopPropagation(); goToPrevious(); }}
            >
                <ChevronLeft size={32} />
            </button>

            {/* Imagem Principal com Container */}
            <div 
                className="relative bg-neutral-900 p-2 rounded-lg shadow-2xl max-w-[90vw] max-h-[90vh] flex items-center justify-center" 
                onClick={(e) => e.stopPropagation()}
            >
                <img 
                    src={images[currentIndex].url} 
                    alt={`Galeria de imagem ${currentIndex + 1}`} 
                    className="max-w-full max-h-[calc(90vh-1rem)] object-contain" // Ajuste para considerar o padding
                />
            </div>

            {/* Botão Próximo */}
            <button 
                className="absolute right-4 top-1/2 -translate-y-1/2 text-white bg-white/10 p-2 rounded-full hover:bg-white/20 transition-colors z-50" 
                onClick={(e) => { e.stopPropagation(); goToNext(); }}
            >
                <ChevronRight size={32} />
            </button>
        </div>
    );
};

export default Lightbox;
